// @ts-nocheck
/* eslint-disable */
/* GENERATED USING build-GemIcons.ts - DO NOT MODIFY */
import { ReactComponent as LogoProphecyName } from '../../../assets/images/Logos/logo-prophecy-name.svg?react';
import { withLogoClass } from '../../withLogoClass';
export const LogoProphecyNameIcon = /* @__PURE__ */ withLogoClass(LogoProphecyName);
